import * as React from "react";
const SvgXRed = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 1L1 7M1 1L7 7", stroke: "#B42318", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgXRed;
